import { Provider } from '@angular/core';
import { EVENT_MANAGER_PLUGINS } from '@angular/platform-browser';

import { ZonelessPlugin } from '@/app/shared/utils/event-plugins/plugins/zoneless.plugin';

import { StopEventPlugin } from '../plugins/stop.plugin';
import { PreventEventPlugin } from '../plugins/prevent.plugin';

const PLUGINS = [PreventEventPlugin, StopEventPlugin, ZonelessPlugin];

export const NG_EVENT_PLUGINS: Provider[] = PLUGINS.map((useClass) => ({
  provide: EVENT_MANAGER_PLUGINS,
  multi: true,
  useClass,
}));

export function provideEventPlugins(): Provider[] {
  return NG_EVENT_PLUGINS;
}
